import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M6.75 3.005v2.25m10.5-2.25v2.25M3 18.755V7.505a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 7.505v11.25m-18 0a2.25 2.25 0 0 0 2.25 2.25h13.5a2.25 2.25 0 0 0 2.25-2.25m-18 0v-7.5a2.25 2.25 0 0 1 2.25-2.25h13.5a2.25 2.25 0 0 1 2.25 2.25v7.5m-9-6h.008v.007H12zm0 2.25h.008v.007H12zm0 2.25h.008v.007H12zm-2.25-2.25h.008v.007H9.75zm0 2.25h.008v.007H9.75zm-2.25-2.25h.008v.007H7.5zm0 2.25h.008v.007H7.5zm6.75-4.5h.008v.007h-.008zm0 2.25h.008v.007h-.008zm0 2.25h.008v.007h-.008zm2.25-4.5h.008v.007H16.5zm0 2.25h.008v.007H16.5z"
    }, null, -1)
  ])))
}
export default { render: render }